import React from "react";
import WarehousePage from "./WarehousePage";

export default function WarehouseStock(props) {
    return (
        <WarehousePage
            {...props}
            page="stock"
        />
    );
}